import ResellersContainer from './ResellersContainer';
export default ResellersContainer;
